import { useMutation } from "@apollo/client";
import { ICardAsDefaultResponse } from "./card-as-default.interface";
import { CARD_AS_DEFAULT } from "./card-as-default.mutation";

export const useCardAsDefault = () => {
  const [
    setCardAsDefault, { data, loading },
  ] = useMutation<{ setCardAsDefault: ICardAsDefaultResponse }>(CARD_AS_DEFAULT);

  const setCardDefault = (cardId: string) => {
    setCardAsDefault({
      variables: { cardId },
    });
  };

  return {
    setCardDefault,
    cardUpdated: data?.setCardAsDefault,
    loading,
  };
};
